import { render } from "./vehicle-details.vue?vue&type=template&id=2ccc5c8a&scoped=true"
import script from "./vehicle-details.vue?vue&type=script&lang=js"
export * from "./vehicle-details.vue?vue&type=script&lang=js"

import "./vehicle-details.vue?vue&type=style&index=0&id=2ccc5c8a&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccc5c8a"]])

export default __exports__